export type { I18NLinkProps } from "./I18NLink.interface";
export { I18NLink } from "./I18NLink";
